import { Dialog, Image } from "@onmo/ui";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { removePopupQueue } from "../../../slices/popup";
import { PopupType } from "../../../constants/popup";
import { setSelectedInventory } from "../../../slices/shop";
import OutGemIcon from "../../../assets/icons/out-gems_1x.webp";
import OutGemIcon2x from "../../../assets/icons/out-gems_2x.webp";
import OutGemIcon3x from "../../../assets/icons/out-gems_3x.webp";
import { useTranslation } from "react-i18next";

type IOurOfGems = {
  onClose?: () => void;
};

const OurOfGems: React.FC<IOurOfGems> = (props) => {
  const { onClose } = props;
  const dispatch = useAppDispatch();
  const { currentPopupId } = useAppSelector((state) => state.popup);
  const { t } = useTranslation();

  const onClickClose = () => {
    onClose?.();
    dispatch(removePopupQueue({ type: PopupType.OutOfGems }));
    dispatch(setSelectedInventory({ selectedInventory: undefined }));
  };

  return (
    <Dialog
      open={currentPopupId === PopupType.OutOfGems}
      mainAction={{
        text: t("close"),
        onClick: onClickClose,
      }}
      icon={
        <Image src={OutGemIcon} src2x={OutGemIcon2x} src3x={OutGemIcon3x} />
      }
      title={t("out_of_gems")}
      description={t("play_more_games_to_get_more_gems")}
    />
  );
};
export default OurOfGems;
